// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--Lk8OA","page":"page--iRdra","column":"column--n0-Ev","blurb":"blurb--nei5f"};